<div #ContainerRef class="blocked_element">
  <ng-container *ngIf="type === 'multi'">
    <ngx-charts-bar-vertical-2d [maxXAxisTickLength]="10" [roundDomains]="true" [barPadding]="0" [groupPadding]="5"
      [scheme]="colorScheme" [results]="values" [gradient]="gradient" [xAxis]="showXAxis" [yAxis]="showYAxis"
      [legend]="legend" [showXAxisLabel]="showXAxisLabel" [showYAxisLabel]="showYAxisLabel" [xAxisLabel]="xAxisLabel"
      [yAxisLabel]="yAxisLabel" [legendPosition]="legendPosition" [legendTitle]="legendTitle"
      [view]="[ContainerRef.offsetWidth - 30, ContainerRef.offsetHeight]">
    </ngx-charts-bar-vertical-2d>
  </ng-container>

  <ngx-charts-pie-chart class="pie_chart" *ngIf="type === 'pie'" [scheme]="colorScheme" [results]="values"
    [gradient]="gradient" [legend]="legend" [legendPosition]="legendPosition" [labels]="showLabels"
    [doughnut]="isDoughnut" [arcWidth]="arcWidth" [legendTitle]="legendTitle" [labelFormatting]="formatDataLabel"
    [view]="[ContainerRef.offsetWidth , ContainerRef.offsetHeight - 60]">
  </ngx-charts-pie-chart>

  <ng-container *ngIf="type === 'bar' || !type">
    <ngx-charts-bar-vertical [maxXAxisTickLength]="10" [roundDomains]="true" [scheme]="colorScheme" [results]="values"
      [gradient]="gradient" [xAxis]="showXAxis" [yAxis]="showYAxis" [legend]="legend" [showXAxisLabel]="showXAxisLabel"
      [showYAxisLabel]="showYAxisLabel" [xAxisLabel]="xAxisLabel" [yAxisLabel]="yAxisLabel"
      [legendPosition]="legendPosition" [legendTitle]="legendTitle"
      [view]="[ContainerRef.offsetWidth - 30, ContainerRef.offsetHeight]">
    </ngx-charts-bar-vertical>
  </ng-container>
  <ng-container *ngIf="type === 'horizontalbar'">
    <ngx-charts-bar-horizontal [maxXAxisTickLength]="10" [roundDomains]="false" [scheme]="colorScheme"
      [results]="values" [gradient]="gradient" [xAxis]="showXAxis" [yAxis]="showYAxis" [legend]="legend"
      [showXAxisLabel]="showXAxisLabel" [showYAxisLabel]="showYAxisLabel" [xAxisLabel]="xAxisLabel"
      [yAxisLabel]="yAxisLabel" [legendPosition]="legendPosition" [legendTitle]="legendTitle"
      [view]="[ContainerRef.offsetWidth - 30, ContainerRef.offsetHeight]">
    </ngx-charts-bar-horizontal>
  </ng-container>
</div>
